import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import "./Dialog.scss";

interface DailogProps {
  children?: React.ReactNode;
  openModal: boolean;
  actionBtnDisabled?: true | false;
  closeBtnPlacement?: "Left" | "Right";
  modelObj: any;
  dialogAction: any;
  backDropClick?: false | true;
  // uniquId?: any;
}

export default function ModalDialog(props: DailogProps) {
  React.useEffect(() => {
    if (props.openModal === true) {
      setTimeout(function () {
        var doc: any = document.querySelector(".modelTitle");
        if (doc != null) {
          //doc.parentElement.id = "mi313";
          doc.focus();
        }
      }, 1000);
    }
  }, [props.openModal]);

  return (
    <div>
      <Dialog
        open={props.openModal}
        PaperProps={{ style: { overflowY: "visible" } }}
        className={props.modelObj.dialogClass}
        onClose={props.backDropClick ? () => {console.log("")} : props.modelObj.closeAction}
        style={{ zIndex: 999 }}
        role="none"
      >
        <DialogTitle className={`modelHeader`} tabIndex={0}>
          <div
            className={`${"modelTitle"}`}
            aria-hidden={true}
            role={"presentation"}
          >
            {props.modelObj.title}
          </div>
        </DialogTitle>
        <DialogContent className="shareInput" style={{ overflowY: "visible" }}>
          {props.modelObj.content && (
            <DialogContentText tabIndex={0}>
              <>{props.modelObj.content}</>
            </DialogContentText>
          )}
          {props.modelObj.isPending && (
            <DialogContentText className="center">
              {props.modelObj.status && (
                <span className="status">{props.modelObj.status}</span>
              )}
              <span className="spinner center_spinner"></span>
            </DialogContentText>
          )}

          {!props.modelObj.isPending && props.children}
        </DialogContent>
        <DialogActions className="buttonBox">
          <div
            className={`dialog-actions ${
              props.modelObj.isPending && "dialog-hidden"
            }`}
          >
            {props && props.modelObj.labelClose && (
              <Button
                variant="contained"
                size="medium"
                className={props.modelObj.closeBtnClass}
                onClick={props.modelObj.closeAction}
                disabled={props.modelObj.closeActionDisable}
              >
                {props.modelObj.labelClose}
              </Button>
            )}
            {props && props.modelObj.labelAction && (
              <Button
                variant="outlined"
                size="medium"
                className={props.modelObj.actionBtnClass}
                onClick={props.dialogAction}
                disabled={props.modelObj.modalActionDisable}
              >
                {props.modelObj.labelAction}
              </Button>
            )}
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}
